module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex"
  }, [_c('div', {
    staticClass: "flex-header"
  }, [_c('tab', {
    attrs: {
      "prevent-default": false
    }
  }, [_c('tab-item', {
    attrs: {
      "selected": _vm.currentUser === 'willPay'
    },
    on: {
      "on-item-click": _vm.handleChange
    }
  }, [_vm._v("待支付")]), _vm._v(" "), _c('tab-item', {
    attrs: {
      "selected": _vm.currentUser === 'paid'
    },
    on: {
      "on-item-click": _vm.handleChange
    }
  }, [_vm._v("已支付")]), _vm._v(" "), _c('tab-item', {
    attrs: {
      "selected": _vm.currentUser === 'all'
    },
    on: {
      "on-item-click": _vm.handleChange
    }
  }, [_vm._v("全部")])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.noticeStr),
      expression: "noticeStr"
    }],
    staticClass: "notice_banner"
  }, [_vm._v(_vm._s(_vm.noticeStr))])], 1), _vm._v(" "), _c('div', {
    staticClass: "flex-content"
  }, [_vm._l((_vm.orderList[_vm.currentUser]['list']), function(item) {
    return _c('group', {
      key: item.id
    }, [_c('form-preview', {
      attrs: {
        "header-label": "付款金额",
        "header-value": '¥' + item.totalPrice,
        "body-items": item.list
      }
    }), _vm._v(" "), _c('flexbox', [(item.order_status === "未付款") ? _c('flexbox-item', [_c('x-button', {
      attrs: {
        "type": "warn"
      },
      nativeOn: {
        "click": function($event) {
          _vm.cancel(item.id)
        }
      }
    }, [_vm._v("取消订单")])], 1) : _vm._e(), _vm._v(" "), (item.order_status === "未付款") ? _c('flexbox-item', [_c('x-button', {
      attrs: {
        "plain": "",
        "type": "primary"
      },
      nativeOn: {
        "click": function($event) {
          _vm.refto(item.id)
        }
      }
    }, [_vm._v("查看")])], 1) : _vm._e(), _vm._v(" "), (item.order_status !== "未付款") ? _c('flexbox-item', [_c('x-button', {
      attrs: {
        "plain": "",
        "type": "primary",
        "link": '/uc/orderDetail/' + item.id
      }
    }, [_vm._v("查看")])], 1) : _vm._e(), _vm._v(" "), (item.order_status === "未付款") ? _c('flexbox-item', [_c('x-button', {
      attrs: {
        "plain": "",
        "type": "primary"
      },
      nativeOn: {
        "click": function($event) {
          _vm.refto(item.id)
        }
      }
    }, [_vm._v("支付")])], 1) : _vm._e()], 1)], 1)
  }), _vm._v(" "), _c('infinite-loading', {
    ref: "infiniteLoading",
    on: {
      "infinite": _vm.infiniteHandler
    }
  }, [_c('divider', {
    attrs: {
      "slot": "no-more"
    },
    slot: "no-more"
  }, [_vm._v("我是底线")]), _vm._v(" "), _c('divider', {
    attrs: {
      "slot": "no-results"
    },
    slot: "no-results"
  }, [_vm._v("我是底线")])], 1)], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-560aaadd"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/uc/OrderLists.vue
// module id = 693
// module chunks = 0